import React, { FC } from "react";
import { TreatmentPricingSummary } from "./TreatmentPricingSummary";
import { PricingLocationSelect } from "../PricingLocationSelect/PricingLocationSelect";
import { LinkDto } from "@apiModels/LinkDto.csharp";
import { LocationSpecializationPriceListParams } from "../../Partials/PricingHighlight/LocationSpecializationPriceListParams.csharp";

export const PriceList: FC<LocationSpecializationPriceListParams> = ({
  summaries,
  locations,
  currentLocationName,
  specializationLink,
}) => {
  const renderListItem = (location: LinkDto) => (
    <a href={location.url}>{location.title}</a>
  );

  return (
    <>
      <PricingLocationSelect
        availableLocations={locations}
        currentLocationName={currentLocationName}
        selectLocationsLabel="Lokasjon"
        renderListItem={renderListItem}
      />
      <h2 className="h5">
        <a
          className="link-list--bare-bones__heading theme-border my-3"
          href={specializationLink.url}
        >
          <span>{specializationLink.title}</span>
        </a>
      </h2>

      {!!summaries.length && (
        <>
          {summaries.map((summary) => (
            <details
              className="details mb-4 theme-inherit-light"
              key={summary.id}
            >
              <TreatmentPricingSummary {...summary} />
            </details>
          ))}
        </>
      )}
    </>
  );
};
